import React from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const EmailInput = ({ setIsActive, setValue }) => {
    const { t } = useTranslation();

    const handleEmailChange = (e) => {
        const next = e.target.value;
        setValue(next);
        setIsActive(EMAIL_PATTERN.test(next));
    };

    return (
        <Input
            type="email"
            size="large"
            inputMode="email"
            autoComplete="email"
            onChange={handleEmailChange}
            placeholder={t("form.emailPlaceholder")}
            className="w-[313px]"
            style={{ height: 61 }}
        />
    );
};

export default EmailInput;
